"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDeepLinkCart = void 0;

var _react = require("react");

var _find2 = _interopRequireDefault(require("lodash/find"));

var _map2 = _interopRequireDefault(require("lodash/map"));

var _isNumber2 = _interopRequireDefault(require("lodash/isNumber"));

var _checkout = require("../../checkout");

var _hooks = require("../../store/hooks");

var _types = require("../../store/types");

var _hooks2 = require("../../menu/hooks");

var _ = require("../");

var _settings = require("../../settings");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// eslint-disable-next-line max-lines-per-function
var useDeepLinkCart = function useDeepLinkCart(_a) {
  var addItems = _a.addItems;

  var _b;

  var dispatch = (0, _.useDeepLinkDispatch)();
  var _c = (0, _.useDeepLinkState)().cart,
      cart = _c === void 0 ? [] : _c;
  var order = (0, _checkout.useOrder)().order;
  var settings = (0, _settings.useSettings)().data;

  var _d = (0, _hooks.useStore)(order === null || order === void 0 ? void 0 : order.locationNumber),
      storeDetails = _d.data,
      isStoreLoading = _d.isLoading,
      isStoreSuccess = _d.isSuccess;

  var status = ((storeDetails === null || storeDetails === void 0 ? void 0 : storeDetails.store) || {}).onlineOrderingStatus;

  var _e = (0, _hooks2.useMenu)({
    locationNumber: order === null || order === void 0 ? void 0 : order.locationNumber,
    serviceMethod: order === null || order === void 0 ? void 0 : order.serviceMethod
  }),
      isMenuSuccess = _e.isSuccess,
      isMenuLoading = _e.isLoading;

  var menuItems = (0, _hooks2.useMenuItems)();
  var isDeeplinkFeature = (_b = settings === null || settings === void 0 ? void 0 : settings.FEATURE) === null || _b === void 0 ? void 0 : _b.DEEP_LINK;
  var isStoreReady = !isStoreLoading && isStoreSuccess;
  var isMenuReady = !isMenuLoading && isMenuSuccess;
  var isOrderable = status === _types.OnlineOrderingStatus.enabled || status === _types.OnlineOrderingStatus.enabledStoreClosed;
  (0, _react.useEffect)(function () {
    if (isDeeplinkFeature && (cart === null || cart === void 0 ? void 0 : cart.length) && isStoreReady && isOrderable && isMenuReady) {
      var addableItems_1 = [];
      (0, _map2["default"])(cart, function (itemId) {
        var menuItem = (0, _isNumber2["default"])(itemId) && (0, _find2["default"])(menuItems, function (item) {
          return item.itemId === itemId;
        });

        if (menuItem) {
          addableItems_1.push(menuItem);
        }
      });

      if (addableItems_1.length && addItems) {
        addItems(addableItems_1);
        dispatch({
          type: _.Actions.UNSET,
          payload: _.StateKeys.Cart
        });
      }
    }
  }, [cart, isStoreReady, isOrderable, isMenuReady, isDeeplinkFeature]);
};

exports.useDeepLinkCart = useDeepLinkCart;